import { addressInfoDisplayStyles as styles } from "@insite/content-library/Components/AddressInfoDisplay";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        &&& {
            p {
                font-style: normal;
                line-height: 1.5;
                font-size: 16px;
            }
        }
    `,
};
